export default __webpack_public_path__ + "static/media/person1@2x.dda89d44.webp";